module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sameAddress":"Same as shipping address","billingInformation":"Billing Information"},"de":{"sameAddress":"Entspricht die Lieferadresse","billingInformation":"Rechnung Information"}}')
  delete Component.options._Ctor
}
